import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Notification } from '../types/notification';

@Injectable()
export class NotificationsService {
  viewAllNotifications = new Subject<void>();
  notificationItemClick = new Subject<Notification>();
  notificationsDropdownOpen = new Subject<boolean>();

  // Notifications
  notificationsEnabled = new BehaviorSubject<boolean>(false);
  notificationsCount = new BehaviorSubject<number>(0);
  notificationsViewAllLabel = new BehaviorSubject<string>('');
  notificationsUnavailableLabel = new BehaviorSubject<string>('');
  notificationsLabel = new BehaviorSubject<string>('');
  notificationsLoadingLabel = new BehaviorSubject<string>('');
  notificationsDelayLabel = new BehaviorSubject<string>('');
  notificationsErrorLabel = new BehaviorSubject<string>('');
  notificationsErrorLinkRefresh = new BehaviorSubject<string>('');
  noNotificationsLabel = new BehaviorSubject<string>('');
  notifications = new BehaviorSubject<Notification[]>([]);
  showUserNotifications = new BehaviorSubject<boolean>(false);
  userNotificationsFirstLoad = new BehaviorSubject<boolean>(false);
  userNotificationLoading = new BehaviorSubject<boolean>(false);

  constructor() {}
}
